var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "card mt-3 mb-0" },
    [
      _c(
        "button",
        {
          staticClass: "btn btn-block btn-default",
          on: { click: _vm.onSubmit },
        },
        [_vm._v("\n        Update Makeup Day Sign-Up Link\n    ")]
      ),
      _vm._v(" "),
      _c("makeup-day-form", {
        attrs: { project: _vm.project },
        on: { success: _vm.onSuccess, failure: _vm.onFailure },
        model: {
          value: _vm.show,
          callback: function ($$v) {
            _vm.show = $$v
          },
          expression: "show",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }